import Skeleton from "react-loading-skeleton";
import useWindowsSize from "@/Hooks/useWindowsSize";
import type { DataProducts } from "@/Models/MPLP/DataProducts";
import type { Price } from "@/Type/Price";

type Props = {
  dataItem: DataProducts;
  isLoading: boolean;
};

export const GridSalePrice = ({ dataItem, isLoading }: Props): JSX.Element => {
  const { width } = useWindowsSize();
  const { salesPrice, listPrice } = dataItem;
  return (
    <div className="d-flext flex-column text-center">
      {isLoading ? (
        <Skeleton />
      ) : salesPrice < listPrice ? (
        <>
          <div
            className={
              width > 800 ? "p-0 text-center" : "p-0 w-100 text-center"
            }>
            <div className="sales">
              <span className="mr-0 cart-price price-plp price-not-found price-pdp">
                <span className="develop___Color_SalePrice__red">
                  ${salesPrice}
                </span>
              </span>
            </div>
          </div>
          <div className={width > 800 ? "p-0" : "p-0 w-100 align-items-center"}>
            <span className="value" content={salesPrice}>
              <span className="strike-through cart-price price-plp price-not-found price-pdp text-truncate develop___subrayado m-0">
                {" "}
                ${listPrice}
              </span>
            </span>
          </div>
        </>
      ) : (
        <>
          <div
            className={
              width > 800 ? "p-0 text-center" : "p-0 w-100 text-center"
            }>
            <div className="sales">
              <span className="mr-0 cart-price price-plp price-not-found price-pdp">
                <span className="develop___salePrice develop___Color_SalePrice__dark">
                  ${salesPrice}
                </span>
              </span>
            </div>
          </div>
          <div className={width > 800 ? "p-3" : "p-3 w-100 align-items-center"}>
            <div className="p-1" content="">
              {""}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export const GridSalePricev2 = ({
  listPrice,
  salesPrice,
  isLoading,
}: {
  listPrice: Price;
  salesPrice: Price;
  isLoading: boolean;
}): JSX.Element => {
  const { width } = useWindowsSize();
  return (
    <div className="d-flext flex-column text-center">
      {isLoading ? (
        <Skeleton />
      ) : salesPrice < listPrice ? (
        <>
          <div
            className={
              width > 800 ? "p-0 text-center" : "p-0 w-100 text-center"
            }>
            <div className="sales">
              <span className="mr-0 cart-price price-plp price-not-found price-pdp">
                <span className="develop___Color_SalePrice__red">
                  ${salesPrice}
                </span>
              </span>
            </div>
          </div>
          <div className={width > 800 ? "p-0" : "p-0 w-100 align-items-center"}>
            <span className="value" content={salesPrice.toString()}>
              <span className="strike-through cart-price price-plp price-not-found price-pdp text-truncate develop___subrayado m-0">
                {" "}
                ${listPrice}
              </span>
            </span>
          </div>
        </>
      ) : (
        <>
          <div
            className={
              width > 800 ? "p-0 text-center" : "p-0 w-100 text-center"
            }>
            <div className="sales">
              <span className="mr-0 cart-price price-plp price-not-found price-pdp">
                <span className="develop___salePrice develop___Color_SalePrice__dark">
                  ${salesPrice}
                </span>
              </span>
            </div>
          </div>
          <div className={width > 800 ? "p-3" : "p-3 w-100 align-items-center"}>
            <div className="p-1" content="">
              {""}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
